<!--
 * @Description: In User Settings Edit
 * @Author: tangqi
 * @Date: 2019-08-10 15:09:15
 * @LastEditTime: 2019-11-14 10:49:31
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div ref="dialog" class="popupBox" v-if="show" @touchmove="cantouchmove ? '' : touchmove" :style="`position:${position}`">
    <div
      class="mask"
      @click.prevent.stop="hideOnBlur && closeTips()"
      :style="`background-color:rgba(0,0,0,${opacity});position:${position}`"
    ></div>
    <div
      class="popupContent"
      :class="{ dialogout: isfadeout }"
      :style="{
        overflow: overflow,
        width: width ? width + '%' : '80%',
        top: top ? parseFloat(top / 75) + 'rem' : '0',
        bottom: top == '0' ? '0' : 'auto',
        background: backgroundColor,
        'border-radius': borderRadius,
      }"
    >
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  name: "xDialog",
  data() {
    return {
      show: false,
      isfadeout: false,
    };
  },
  props: {
    value: {}, // 是否显示，使用v-model绑定
    isDestroy: {
      //隐藏时是否销毁组件
      type: Boolean,
      default: false,
    },
    cantouchmove: {
      //是否允许滚动
      type: Boolean,
    },
    overflow: {
      //溢出属性
      type: String,
      default: "hidden",
    },
    position: {
      //定位属性
      type: String,
      default: "absolute",
    },
    opacity: {
      type: Number,
      default: 0.2,
    },
    width: {
      type: String,
      default: "80",
    },
    top: {
      type: String,
      default: "0",
    },
    backgroundColor: {
      type: String,
      default: "#ffffff",
    },
    borderRadius: {
      type: String,
      default: "3px",
    },
    hideOnBlur: {
      type: Boolean,
      default: !0,
    },
  },
  mounted(){
    // this.$refs.dialog.vShow = this.show
  },
  watch: {
    value: {
      handler(newval, oldval) {
        this.show = newval;
      },
      immediate: true
    },
    show(val) {
      this.$emit("input", val);
    },
  },
  computed: {},
  methods: {
    /** 关闭弹窗 */
    closeMask() {
      this.isfadeout = true;
      setTimeout(() => {
        this.show = false;
        this.isfadeout = false;
      }, 200);
    },
    closeTips() {
      // 注册触发父组件对应的closetips事件，并传递！1
      this.$emit("close", !1);
      this.closeMask();
    },
    delayHandler() {
      // this.closeTips();
    },
    touchmove(e) {
      e.preventDefault();
    },
  },
};
</script>
<style rel="stylesheet/stylus" lang="stylus" scoped>
@import '~@/assets/css/mixin.styl'
.popupBox
  left: 0;
  right: 0;
  height 100%
  position fixed
  top 0
  display flex
  align-items center
  justify-content center
  .mask
    width 100%
    height 100%
    left 0
    top 0
    z-index 1000
  .popupContent
    // position fixed
    display flex
    justify-content center
    z-index 5000
    // width 100%
    max-width 100%
    max-height 100%
    overflow-y auto
    // top 0
    // right 0
    // bottom 0
    // left 0
    // margin auto
    text-align center
    transition dialog-in
    -webkit-animation-iteration-count 1 /* 动画次数 */
    -webkit-animation-name dialog-in
    -webkit-animation-duration 0.5s
    // overflow hidden
    &.dialogout
      transition dialog-out
      -webkit-animation-iteration-count 1 /* 动画次数 */
      -webkit-animation-name dialog-out
      -webkit-animation-duration 0.2s
  .actionBox
    padding rpx(30)
    font-size rpx(30)
    color #666666
    /* height rpx(80) */
    .confirm
      color #f08300
@keyframes dialog-in
  from
    -webkit-transform scale(1.185)
    transform scale(1.185)
    opacity 0
  to
    opacity 1 /* 结尾状态 透明度为1 */
    transform scale(1)
    -webkit-transform scale(1)
@keyframes dialog-out
  from
    opacity 1 /* 结尾状态 透明度为1 */
    transform scale(1)
    -webkit-transform scale(1)
  to
    -webkit-transform scale(0.85)
    transform scale(0.85)
    opacity 0
</style>



// WEBPACK FOOTER //
// src/starcharge/components/Popup/x-dialog.vue